// extracted by mini-css-extract-plugin
module.exports = {"detail":"index-module_detail_1ivod"};